import React from "react";
import {
  Box,
  Card,
  Container,
  Stack,
  Typography,
  Checkbox,
  Grid,
  MenuItem,
  TextField,
  Button,
} from "@mui/material";
import { useState, useEffect } from "react";
import Link from "@mui/material/Link";
import axios from "axios";
import { API } from "../../pages/backend";
import { useNavigate, useLocation } from "react-router-dom";
import toast from "react-hot-toast";
import { useForm, Controller } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import data from "../dropDown";
import Swal from "sweetalert2";
import Spinner from "../ui/Spinner";
import { useDispatch } from "react-redux";
import { loggedInUser, setUser } from "../../store/reducers/user";
import FormButton from "../ui/button/FormButton";
import InputField from "../forms/input/TextInput/InputField";
import { apiRequest } from "../../services/auth";

const RegisterTedac = ({
  examType = "TEDAC REGISTRATION",
  url,
  navigateTo,
  homeLink
}) => {
  const formSchema = yup.object().shape({
    phoneNumber: yup
      .string()
      .required("Phone Number is required")
      .matches(/^[0-9]{1,11}$/, "Phone number must be 11 digits"),
    payerId: yup.string().required("Payer ID is required"),

    password: yup
      .string()
      .required("Password is required")
      .matches(
        /^(?=.*[A-Za-z])(?=.*[0-9])(?=.*[!@#$%^&*])[A-Za-z0-9!@#$%^&*]{8,}$/,
        "Password must be at least 8 characters and must contain at least an alphabet, a number, and a special character (!@#$%^&*)"
      ),
    confirm: yup
      .string()
      .oneOf([yup.ref("password"), null], "Passwords must match")
      .required("Confirm Password is required")
      .matches(
        /^(?=.*[A-Za-z])(?=.*[0-9])(?=.*[!@#$%^&*])[A-Za-z0-9!@#$%^&*]{8,}$/,
        "Password must be at least 8 characters and must contain at least an alphabet, a number, and a special character (!@#$%^&*)"
      ),
  });

  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const { Lga } = data;

  // confirm password

  // // State for the selected LGA
  // const [selectedLGA, setSelectedLGA] = useState("");

  // // Update the selected LGA
  // const handleLGAChange = (event) => {
  // const handleLGAChange = (event) => {
  //     setSelectedLGA(event.target.value);
  // };
  // API

  // const navigate = useNavigate();

  // useform
  const {
    setValue,
    handleSubmit,
    formState: { errors },
    trigger,
  } = useForm({
    resolver: yupResolver(formSchema),
  });

  // const response = await axios.post(`${API}auth/college/signup`, body);
  const Register = async (value) => {
    // value.preventDefault()
    // console.log(value)
    // alert("not")
    // Check for client-side validation errors

    // const body = {
    //     lastName,
    //     firstName,
    //     middleName,
    //     phoneNumber: phone,
    //     payerId,
    //     lga: selectedLGA,
    //     email,
    //     password,
    //     confirm: confirmPassword,
    //     address,
    // };
    console.log(value);
    const isValid = await trigger(); // Trigger validation
    // setLoading(true);
    // console.log(isValid)
    // Do not proceed if there are validation errors
    if (!isValid) return;
    setLoading(true);
    // delete value.confirm
    try {
      const res = await apiRequest({
        method: "post",
        url: url,
        payload: value,
        successMessage: " ",
        showError: true,
      });
      if (res?.data?.status === "success") {
        navigate(navigateTo);
        Swal.fire({
          title: "Successful",
          text: res?.data?.data?.message,
          icon: "success",
          confirmButtonText: "Ok",
        });
        // console.log(res?.data?.response?.user)
        // console.log(res?.data?.response)
        console.log(res?.data?.data);
        dispatch(setUser(res?.data?.data));
      } else if (res?.data?.status === "failure") {
        Swal.fire({
          title: "Error",
          text: res?.data?.message,
          icon: "error",
          confirmButtonText: "Ok",
        });
      }
      // console.log(res?.data?.response?.user)
      // dispatch(setUser(res?.data?.response));
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
    // setLoading(false);
  };

  const location = useLocation();
  const [loginPage, setLoginPage] = useState(null);

  useEffect(() => {
    if (location.pathname === "/public/payment/register") {
      setLoginPage("/public/payment/login");
    } else if (location.pathname === "/model/payment/register") {
      setLoginPage("/model/payment/login");
    } else if (location.pathname === "/tedac/payment/register") {
      setLoginPage("/tedac/payment/login");
    }
  }, [location.pathname]);

  return (
    <div className="reg-login-card">
      <Container>
        <Card
          className="register-card"
          elevation={5}
          style={{
            boxShadow: "2px 2px 5px 0px rgba(0, 0, 0, 0.5)",
            borderRadius: "10px",
          }}
        >
          <Container component="div">
            <Stack style={{ textAlign: "center", paddingTop: "2rem" }}>
              <Typography variant="h5" style={{ fontWeight: "bold" }}>
                CERTIFICATION REGISTRATION
              </Typography>
              <Typography variant="subtitle2" style={{ marginTop: "10px" }}>
                {" "}
                {examType}{" "}
              </Typography>
            </Stack>
            <div
              style={{
                marginTop: "3rem",
                marginRight: "2.5rem",
                marginLeft: "2.5rem",
              }}
            >
              <form
                style={{ marginLeft: "1.5rem" }}
                onSubmit={handleSubmit(Register)}
                // onSubmit={Register}
              >
                <div>
                  <Grid container spacing={2}>
                    <Grid item xs={6}>
                      <InputField
                        name="firstName"
                        label="First Name"
                        type="firstName"
                        placeholder="First Name"
                        // value={firstName}
                        onChange={(e) => {
                          setValue("firstName", e.target.value.trim());
                        }}
                        style={{ height: "100%" }}
                      />
                    </Grid>
                    <Grid item xs={6}>
                      <InputField
                        name="lastName"
                        label="Last Name"
                        type="lastName"
                        placeholder="Last Name"
                        // value={lastName}
                        onChange={(e) => {
                          setValue("lastName", e.target.value.trim());
                        }}
                        style={{ height: "100%" }}
                      />
                    </Grid>
                  </Grid>
                </div>
                <div>
                  <Grid container spacing={2}>
                    {/* <Grid item xs={6}>
                      <InputField
                        name="lastName"
                        label="Last Name"
                        type="lastName"
                        placeholder="Last Name"
                        // value={lastName}
                        onChange={(e) => {
                          setValue("lastName", e.target.value);
                        }}
                        style={{ height: "100%" }}
                      />
                    </Grid> */}
                    <Grid item xs={6}>
                      <InputField
                        name="email"
                        label="Email"
                        type="email"
                        placeholder="Email"
                        // value={email}
                        onChange={(e) => {
                          setValue("email", e.target.value.trim());
                        }}
                        style={{ height: "100%" }}
                      />
                    </Grid>
                    <Grid item xs={6}>
                      <InputField
                        name="phoneNumber"
                        label="Phone Number"
                        type="phoneNumber"
                        placeholder="Phone Number"
                        // value={phone}
                        onChange={(e) => {
                          setValue("phoneNumber", e.target.value.trim());
                        }}
                        style={{ height: "100%" }}
                      />
                    </Grid>
                  </Grid>
                </div>

                <div>
                  <Grid container spacing={2}>
                    <Grid item xs={6}>
                      <InputField
                        name="password"
                        label="Password"
                        type="password"
                        placeholder="Password"
                        // value={password}
                        password
                        onChange={(e) => {
                          setValue("password", e.target.value.trim());
                        }}
                        style={{ height: "100%" }}
                      />
                      <Typography
                        sx={{
                          color: "#e53e3e",
                          fontSize: "14px",
                          fontWeight: "bold",
                        }}
                        style={{
                          visibility: errors.password ? "visible" : "hidden",
                        }}
                      >
                        {errors.password?.message}
                      </Typography>
                    </Grid>
                    <Grid item xs={6}>
                      <InputField
                        name="confirm"
                        label=" Confirm Password"
                        type="confirmPassword"
                        placeholder=" Confirm Password"
                        password
                        // value={confirmPassword}
                        onChange={(e) => {
                          setValue("confirm", e.target.value.trim());
                        }}
                        style={{ height: "100%" }}
                      />
                      <Typography
                        sx={{
                          color: "#e53e3e",
                          fontSize: "14px",
                          fontWeight: "bold",
                        }}
                        style={{
                          visibility: errors.password ? "visible" : "hidden",
                        }}
                      >
                        {errors.password?.message}
                      </Typography>
                    </Grid>
                  </Grid>
                </div>
                <div>
                  <Grid>
                    <InputField
                      name="payerID"
                      label="Payer ID"
                      type="payerId"
                      placeholder="Payer ID"
                      // value={payerId}
                      onChange={(e) => {
                        setValue("payerId", e.target.value.trim());
                      }}
                      style={{ height: "100%" }}
                    />
                    <Typography
                      sx={{
                        color: "#e53e3e",
                        fontSize: "14px",
                        fontWeight: "bold",
                      }}
                      style={{
                        visibility: errors.payerId ? "visible" : "hidden",
                      }}
                    >
                      {errors.payerId?.message}
                    </Typography>
                  </Grid>
                </div>
                <div>
                  <Grid>
                    {/* <InputField
                      name="address"
                      label=" Address"
                      type="address"
                      placeholder=" Address"
                      // value={address}
                      onChange={(e) => {
                        setValue("address", e.target.value);
                      }}
                      style={{ height: "100%" }}
                    /> */}
                  </Grid>
                </div>
                <div>
                  {/* <Grid>
                    <TextField
                      label="Select Local Government Area"
                      select
                      // {...field}
                      onChange={(e) => {
                        setValue("lga", e.target.value);
                      }}
                      style={{
                        height: "100%",
                        width: "100%",
                        marginTop: "1rem",
                      }}
                    >
                      {Lga.map((lgaItem) => (
                        <MenuItem key={lgaItem.ledId} value={lgaItem.ledId}>
                          {lgaItem.name}
                        </MenuItem>
                      ))}
                    </TextField>
                  </Grid> */}
                </div>
                {/* <div style={{ marginTop: '10px' }}>
                                    <Checkbox
                                        id='check'
                                        checked={rememberMe}
                                        onChange={handleRememberMeChange}
                                        color='secondary'
                                    />
                                    <Typography variant='p'>Remember Me</Typography>
                                </div> */}
                <Stack style={{ marginTop: "10px" }}>
                  {/* Register Button */}
                  <FormButton
                    type="submit"
                    label={loading ? <Spinner width="5%" /> : "Register"}
                    width="full"
                    // onClick={Register}
                  />
                </Stack>

                <Typography
                  variant="body2"
                  fontWeight="normal"
                  marginTop="10px"
                  textAlign="center"
                  cursor="pointer"
                  color="#807c7c"
                >
                  Already signed up? {"   "}
                  {"   "}
                  <Link
                    href={loginPage}
                    style={{
                      textDecoration: "none",
                    }}
                    color="secondary"
                  >
                    {"  "}
                    Login
                  </Link>
                </Typography>
                <Typography
                  variant="body2"
                  fontWeight="normal"
                  marginTop="10px"
                  textAlign="center"
                  cursor="pointer"
                  color="secondary"
                >
                  <Link
                    href={homeLink}
                    style={{
                      textDecoration: "none",
                    }}
                    color="secondary"
                  >
                    {"  "}
                    Back to home page
                  </Link>
                </Typography>
              </form>
            </div>
            {/* <Footer /> */}
          </Container>
        </Card>
      </Container>
    </div>
  );
};

export default RegisterTedac;
